var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBell24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke secondary-fill",
    d: "M19 19.42h1.32c.93 0 1.68-1.07 1.68-2 0-1.5-1-1.5-1-2.92v-1.4c0-1.88-.98-3.72-2-4.36A5.1 5.1 0 0 0 16.41 8a4.6 4.6 0 0 0-3.01 1.1c-.15.13-.29.28-.41.46A6.82 6.82 0 0 0 12 13.1v1.4c0 1.42-1 1.42-1 2.92 0 .45.1.8.23 1.08.36.7 1.05.9 1.45.92H14m5 0v.66c0 1.1-1 1.92-2.5 1.92s-2.5-.82-2.5-1.92v-.66m5 0h-5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M7 4H5C3.9 4 3 4.9 3 5.98v3.58M7 4V3m0 1v1.5M7 4h8m0 0v1.5M15 4V3m0 1h2c1.1 0 2 .89 2 1.98M3 9.56v6.96c0 1.1.9 1.98 2 1.98h3.5M3 9.56h7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBell24);
export default __webpack_public_path__ + "static/media/calendar_bell_24.1e4f184348a453461f5aa531989dfe0c.svg";
export { ForwardRef as ReactComponent };